export default "__VITE_ASSET__Bsze1zRl__"